export const MainColor:string = "#319795";